import { render, staticRenderFns } from "./deliverySummary.vue?vue&type=template&id=566dbd42&scoped=true&"
import script from "./deliverySummary.vue?vue&type=script&lang=js&"
export * from "./deliverySummary.vue?vue&type=script&lang=js&"
import style0 from "./deliverySummary.vue?vue&type=style&index=0&id=566dbd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566dbd42",
  null
  
)

export default component.exports